import React from 'react';
import styled from 'styled-components';
import { device } from 'js/config/style.js';

import AddressInput from 'js/components/common/AddressInput';
import Container from './Container';
import ShippingBoxSection from './ShippingBoxSection';
import TextNoWrap from '../TextNoWrap';

import {inject, observer} from "mobx-react";


const StyledTextNoWrap = styled(TextNoWrap)`
  @media(min-width: ${device.tablet}) {
    margin: 0 70px;
  }
`;

const StyledTextNoWrapAddressRequired = styled(TextNoWrap)`
  @media(min-width: ${device.tablet}) {
    margin: 0 70px;
  }
`;

export default inject('page')(
  observer(({ page }) => {
    return (
      <Container style={{cursor:'pointer'}}>
        <ShippingBoxSection>
          <StyledTextNoWrap>Buy this item and get it within 24hrs</StyledTextNoWrap>
        </ShippingBoxSection>
        <ShippingBoxSection style={{cursor:'pointer'}}>
          <span>
          <AddressInput
            name="address"
            showError={page.hasAddressError}
            address={page.address}
            onChange={page.addressSaved}
            placeholder="Enter your street address"
            flat={!page.showShippingSelection}
            className="tw-w-full"
          />
        </span>
        </ShippingBoxSection>
        {page.address.hasAddress === false ? (
          <ShippingBoxSection>
            <StyledTextNoWrapAddressRequired>
              <span style={{fontSize:'12px', color:'black', fontWeight:'normal'}}>Note: Enter a valid address to see shipping options</span>
            </StyledTextNoWrapAddressRequired>
          </ShippingBoxSection>
        ):''}

        <ShippingBoxSection>
          <button
            className={page.address.hasAddress === true ? 'btn btn-pod btn-primary' : 'btn btn-pod btn-warning'}
            disabled={page.address.hasAddress === false}
            onClick={page.nextStep}
          >
            See shipping options
          </button>
        </ShippingBoxSection>
      </Container>
    );
  })
);

// function ShippingBox ({
//   address,
//   addressSaved,
//   page,
//   nextStep,
// }) {
//
//
// }
//
// export default ShippingBox;
